<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="S&eacute;rie C6100">
     S&eacute;rie C6100
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_pt" title="Informa&ccedil;&otilde;es sobre seguran&ccedil;a">
     Informa&ccedil;&otilde;es sobre seguran&ccedil;a
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href="safety.html#d0e23" title="Conven&ccedil;&otilde;es">
      Conven&ccedil;&otilde;es
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_pt" title="Aprender sobre a impressora">
     Aprender sobre a impressora
    </a>
   </p>
   <div id="divd0e187">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_pt" title="Localiza&ccedil;&atilde;o das informa&ccedil;&otilde;es sobre a impressora">
      Localiza&ccedil;&atilde;o das informa&ccedil;&otilde;es sobre a impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_pt" title="Sele&ccedil;&atilde;o de um local para a impressora">
      Sele&ccedil;&atilde;o de um local para a impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-models-topic.html#configured-models_pt" title="Configura&ccedil;&otilde;es da impressora">
      Configura&ccedil;&otilde;es da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_pt" title="Conectando cabos">
      Conectando cabos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_pt" title="Uso do painel de controle">
      Uso do painel de controle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-power-button-and-indicator-light-topic.html#understanding-status-power-button-and-indicator-light_pt" title="Aprender sobre o status do bot&atilde;o liga/desliga e da luz indicadora">
      Aprender sobre o status do bot&atilde;o liga/desliga e da luz indicadora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_pt" title="Uso da tela inicial">
      Uso da tela inicial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-map-sfp-topic.html#menus-map-sfp_pt" title="Mapa de menus">
      Mapa de menus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_pt" title="Impress&atilde;o de uma p&aacute;gina de configura&ccedil;&otilde;es de menu">
      Impress&atilde;o de uma p&aacute;gina de configura&ccedil;&otilde;es de menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_pt" title="Papel inaceit&aacute;vel">
      Papel inaceit&aacute;vel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_pt" title="Uso de papel reciclado">
      Uso de papel reciclado
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_pt" title="Configura&ccedil;&atilde;o e uso dos aplicativos da tela inicial">
     Configura&ccedil;&atilde;o e uso dos aplicativos da tela inicial
    </a>
   </p>
   <div id="divd0e1161">
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_pt" title="Personaliza&ccedil;&atilde;o da tela inicial">
      Personaliza&ccedil;&atilde;o da tela inicial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_pt" title="Usando a Personaliza&ccedil;&atilde;o da exibi&ccedil;&atilde;o">
      Usando a Personaliza&ccedil;&atilde;o da exibi&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-forms-and-favorites-topic.html#setting-up-forms-and-favorites_pt" title="Configura&ccedil;&atilde;o de Forms and Favorites">
      Configura&ccedil;&atilde;o de Forms and Favorites
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_pt" title="Configurando as Configura&ccedil;&otilde;es Eco">
      Configurando as Configura&ccedil;&otilde;es Eco
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_pt" title="Como usar o Suporte ao cliente">
      Como usar o Suporte ao cliente
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_pt" title="Como usar o gerador de c&oacute;digos de QR">
      Como usar o gerador de c&oacute;digos de QR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_pt" title="Como configurar o aplicativo de cotas do dispositivo">
      Como configurar o aplicativo de cotas do dispositivo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-google-drive-topic.html#using-google-drive_pt" title="Usando o Google Drive">
      Usando o Google Drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1389" title="Gerenciando contatos">
      Gerenciando contatos
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_pt" title="Configura&ccedil;&atilde;o e uso dos recursos de acessibilidade">
     Configura&ccedil;&atilde;o e uso dos recursos de acessibilidade
    </a>
   </p>
   <div id="divd0e1508">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_pt" title="Ativando modo de amplia&ccedil;&atilde;o">
      Ativando modo de amplia&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_pt" title="Ativa&ccedil;&atilde;o do Voice Guidance">
      Ativa&ccedil;&atilde;o do Voice Guidance
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_pt" title="Ajustando a velocidade de fala no Voice Guidance">
      Ajustando a velocidade de fala no Voice Guidance
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_pt" title="Ativando senhas ou n&uacute;meros de identifica&ccedil;&atilde;o pessoal falados">
      Ativando senhas ou n&uacute;meros de identifica&ccedil;&atilde;o pessoal falados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_pt" title="Navegando pela tela usando gestos">
      Navegando pela tela usando gestos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_pt" title="Usando o teclado no visor">
      Usando o teclado no visor
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_pt" title="Carregamento de papel e m&iacute;dia especial">
     Carregamento de papel e m&iacute;dia especial
    </a>
   </p>
   <div id="divd0e1711">
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#setting-paper-size-type_pt" title="definindo o tamanho e o tipo da m&iacute;dia especial">
      definindo o tamanho e o tipo da m&iacute;dia especial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_pt" title="Defini&ccedil;&atilde;o das configura&ccedil;&otilde;es do papel Universal">
      Defini&ccedil;&atilde;o das configura&ccedil;&otilde;es do papel Universal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_pt" title="Carregamento de bandejas">
      Carregamento de bandejas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_pt" title="Carregamento do alimentador multifun&ccedil;&atilde;o">
      Carregamento do alimentador multifun&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_pt" title="Vincula&ccedil;&atilde;o de bandejas">
      Vincula&ccedil;&atilde;o de bandejas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_pt" title="Impress&atilde;o">
     Impress&atilde;o
    </a>
   </p>
   <div id="divd0e1897">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_pt" title="Impress&atilde;o de um computador">
      Impress&atilde;o de um computador
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-forms-topic.html#printing-forms_pt" title="Imprimindo formul&aacute;rios">
      Imprimindo formul&aacute;rios
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1948" title="Impress&atilde;o a partir de um dispositivo m&oacute;vel">
      Impress&atilde;o a partir de um dispositivo m&oacute;vel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-h2-topic.html#printing-from-flash-drive-h2_pt" title="Impress&atilde;o a partir de uma unidade flash">
      Impress&atilde;o a partir de uma unidade flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_pt" title="Unidades flash e tipos de arquivo suportados">
      Unidades flash e tipos de arquivo suportados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_pt" title="Configurar trabalhos confidenciais">
      Configurar trabalhos confidenciais
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-h-topic.html#printing-confidential-and-other-held-jobs-h_pt" title="Imprimindo trabalhos suspensos">
      Imprimindo trabalhos suspensos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_pt" title="Impress&atilde;o de uma lista de amostras de fontes">
      Impress&atilde;o de uma lista de amostras de fontes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_pt" title="Cancelamento de um trabalho de impress&atilde;o">
      Cancelamento de um trabalho de impress&atilde;o
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_pt" title="Protegendo a impressora">
     Protegendo a impressora
    </a>
   </p>
   <div id="divd0e2338">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_pt" title="Localiza&ccedil;&atilde;o do slot de seguran&ccedil;a">
      Localiza&ccedil;&atilde;o do slot de seguran&ccedil;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_pt" title="Apagar a mem&oacute;ria da impressora">
      Apagar a mem&oacute;ria da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_pt" title="Limpando a mem&oacute;ria do disco r&iacute;gido da impressora">
      Limpando a mem&oacute;ria do disco r&iacute;gido da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption_pt" title="Configurando a criptografia de disco r&iacute;gido da impressora">
      Configurando a criptografia de disco r&iacute;gido da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_pt" title="Restaura&ccedil;&atilde;o das configura&ccedil;&otilde;es padr&atilde;o de f&aacute;brica">
      Restaura&ccedil;&atilde;o das configura&ccedil;&otilde;es padr&atilde;o de f&aacute;brica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_pt" title="Declara&ccedil;&atilde;o de volatilidade">
      Declara&ccedil;&atilde;o de volatilidade
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_pt" title="Manuten&ccedil;&atilde;o da impressora">
     Manuten&ccedil;&atilde;o da impressora
    </a>
   </p>
   <div id="divd0e2548">
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#d0e2553" title="Ajustando o volume do alto-falante">
      Ajustando o volume do alto-falante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-using-printer-control-panel-topic.html#d0e2645" title="Colocando em rede">
      Colocando em rede
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_pt" title="Configura&ccedil;&atilde;o da impress&atilde;o serial (somente no Windows)">
      Configura&ccedil;&atilde;o da impress&atilde;o serial (somente no Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_pt" title="Limpeza da impressora">
      Limpeza da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_pt" title="Solicita&ccedil;&atilde;o de pe&ccedil;as e suprimentos">
      Solicita&ccedil;&atilde;o de pe&ccedil;as e suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-developer-unit-topic.html#d0e3211" title="Troca de pe&ccedil;as e suprimentos">
      Troca de pe&ccedil;as e suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#storing-supplies_pt" title="Armazenamento de suprimentos">
      Armazenamento de suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e3681" title="Transporte da impressora">
      Transporte da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e3737" title="Economia de energia e papel">
      Economia de energia e papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e3875" title="Reciclagem">
      Reciclagem
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_pt" title="Limpeza de atolamentos">
     Limpeza de atolamentos
    </a>
   </p>
   <div id="divd0e3929">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_pt" title="Para evitar atolamentos">
      Para evitar atolamentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_pt" title="Para identificar os locais dos atolamentos">
      Para identificar os locais dos atolamentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-trays-topic.html#jam-in-trays_pt" title="Atolamento de papel nas bandejas">
      Atolamento de papel nas bandejas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jams-in-mpf-topic.html#jams-in-mpf_pt" title="Atolamento de papel no alimentador multiuso">
      Atolamento de papel no alimentador multiuso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-standard-bin-topic.html#jam-in-standard-bin_pt" title="Atolamento de papel na bandeja padr&atilde;o">
      Atolamento de papel na bandeja padr&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-door-b-topic.html#jam-in-door-b_pt" title="Atolamento de papel na porta B">
      Atolamento de papel na porta B
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-finisher-bin-topic.html#jam-in-finisher-bin_pt" title="Atolamento de papel na bandeja do encadernador">
      Atolamento de papel na bandeja do encadernador
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-door-g-topic.html#staple-jam-door-g_pt" title="Atolamento de grampo na porta G">
      Atolamento de grampo na porta G
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_pt" title="Solu&ccedil;&atilde;o de problemas">
     Solu&ccedil;&atilde;o de problemas
    </a>
   </p>
   <div id="divd0e4273">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e4276" title="Problemas de conex&atilde;o de rede">
      Problemas de conex&atilde;o de rede
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e4491" title="Problemas de op&ccedil;&otilde;es de hardware">
      Problemas de op&ccedil;&otilde;es de hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e4763" title="Problemas com suprimentos">
      Problemas com suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_pt" title="Problemas na bandeja de papel">
      Problemas na bandeja de papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_pt" title="Problemas de impress&atilde;o">
      Problemas de impress&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#d0e7305" title="Problemas de qualidade de cor">
      Problemas de qualidade de cor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_pt" title="Entrando em contato com o suporte ao cliente">
      Entrando em contato com o suporte ao cliente
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_pt" title="Atualiza&ccedil;&atilde;o e migra&ccedil;&atilde;o">
     Atualiza&ccedil;&atilde;o e migra&ccedil;&atilde;o
    </a>
   </p>
   <div id="divd0e7540">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e7543" title="Hardware">
      Hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7869" title="Software">
      Software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e7945" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_pt" title="Avisos">
     Avisos
    </a>
   </p>
   <div id="divd0e8014">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8017" title="Informa&ccedil;&otilde;es sobre o produto">
      Informa&ccedil;&otilde;es sobre o produto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8034" title="Aviso de edi&ccedil;&atilde;o">
      Aviso de edi&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_pt" title="Marcas comerciais">
      Marcas comerciais
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_pt" title="Avisos de licenciamento">
      Avisos de licenciamento
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_pt" title="N&iacute;veis de emiss&atilde;o de ru&iacute;do">
      N&iacute;veis de emiss&atilde;o de ru&iacute;do
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8122" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8149" title="Bateria recarreg&aacute;vel de &iacute;ons de l&iacute;tio">
      Bateria recarreg&aacute;vel de &iacute;ons de l&iacute;tio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_pt" title="Norma (UE) 2023/1542">
      Norma (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_pt" title="A devolu&ccedil;&atilde;o de cartuchos Lexmark para reutiliza&ccedil;&atilde;o ou reciclagem">
      A devolu&ccedil;&atilde;o de cartuchos Lexmark para reutiliza&ccedil;&atilde;o ou reciclagem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_pt" title="Aviso de sensibilidade &agrave; est&aacute;tica">
      Aviso de sensibilidade &agrave; est&aacute;tica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_pt" title="Informa&ccedil;&otilde;es sobre temperatura">
      Informa&ccedil;&otilde;es sobre temperatura
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_pt" title="Aviso sobre laser">
      Aviso sobre laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-advisory-label_pt" title="Etiqueta de aviso sobre laser">
      Etiqueta de aviso sobre laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#notice-to-users-of-products-in-brazil_pt" title="Aviso aos usu&aacute;rios de produtos no Brasil">
      Aviso aos usu&aacute;rios de produtos no Brasil
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue